var _circle, _path, _path2, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 43,
    r: 4.5,
    fill: "#374151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 36,43 A 14,14 0 0,1 64,43",
    fill: "none",
    stroke: "#374151",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 26,43 A 24,24 0 0,1 74,43",
    fill: "none",
    stroke: "#374151",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 16,43 A 34,34 0 0,1 84,43",
    fill: "none",
    stroke: "#374151",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 73,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 28,
    textAnchor: "middle",
    fill: "#374151"
  }, "433")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 91,
    fontFamily: "Arial, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    textAnchor: "middle",
    fill: "#374151"
  }, "MHz")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.b267cefc8f8806732b54f2fa7723a2e0.svg";
export { ForwardRef as ReactComponent };